import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import { useParams } from 'react-router-dom';
import Forms from './components/Forms';

const MotoristaCadastro = ({ isReadOnly = false, hideHeader = false }) => {
  const { id } = useParams();
  const isEditMode = Boolean(id);

  if (hideHeader) {
    return <Forms isReadOnly={isReadOnly} hideHeader={hideHeader} />;
  }

  return (
    <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader
            title=""
            routeSegments={[
              { name: 'Inicio' },
              { name: 'Motoristas', route: '/pages/motoristas' },
              { name: isEditMode ? 'Editar' : 'Novo' },
            ]}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <Forms isReadOnly={isReadOnly} />
        </Col>
      </Row>
    </Container>
  );
};

export default MotoristaCadastro;
